query getMarketingPlans {
  plans: getMarketingPlans {
    id
    startDate
    status
    topicName
    postCount
    planType
    slots {
      scheduledLocal {
        date
      }
    }
  }
}
